import styles from "./FilterAccordion.module.css";

const FilterAccordion = ({ title, children, isActive, toggleAccordion }) => {
  return (
    <div className={`${styles["accordion__section"]} ${styles["filerSection"]}`}>
      <button
        className={`${styles["accordion"]} ${isActive ? styles["active"] : ""}`}
        onClick={toggleAccordion}
      >
        <span className={styles["accordion__title"]}>{title}</span>
        {isActive ? (
          <img src="/icons/minus.svg" alt="Collapse" width={18} height={18} />
        ) : (
          <img src="/icons/plus.svg" alt="Expand" width={18} height={18} />
        )}
      </button>
      <div
        className={`${styles["accordion__content"]}`}
        style={{
          maxHeight: isActive ? "500px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.3s ease-in-out",
        }}
      >
        <div className={styles["accordion__text"]}>{children}</div>
      </div>
    </div>
  );
};

export default FilterAccordion;
